import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63578d28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "fee-table" }


import STable from '@/components/Table/index.vue'
import { feeColumns } from './data'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  table: {
    type: Array,
    default: () => ([])
  }
},
  emits: ['update:visible'],
  setup(__props, { emit: emits }) {




return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', false))),
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(STable, {
          tableData: __props.table,
          columns: _unref(feeColumns),
          showPagination: false
        }, null, 8, ["tableData", "columns"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})